import * as Yup from 'yup';

import history from 'browserHistory';
import { TripStatusIds } from 'entities/Trip';
import { OperatingProcedures } from 'utils/enums';

const validationSchema = (
  status: TripStatusIds | number,
  operatingProcedure: string,
  useTransportDoc: boolean = true,
) => {
  const pathMode = history.location.pathname.split('/')[1];

  const isOrdering = pathMode === 'ordering';
  const isSecurity = pathMode === 'security';
  const isKiosk = pathMode === 'kiosk';
  const isDirector = pathMode === 'director';

  return Yup.object().shape({
    entryVehicleWeight:
      isKiosk ||
      ((operatingProcedure === OperatingProcedures.RulesTwo || operatingProcedure === OperatingProcedures.RulesThree) &&
        isOrdering)
        ? Yup.number()
        : Yup.number()
            .positive('Значення має бути додатнім')
            .moreThan(0, 'Значення має бути більше 0')
            .lessThan(2000001, 'Максимальне значення 2000000')
            .integer('Значення має бути цілим числом')
            .required('Поле "Вага" обов\'язкове'),
    vehicle: Yup.object().shape(
      {
        licensePlate: Yup.string()
          .trim()
          .nullable()
          .min(4, 'Поле "Номер автомобіля" повинно містити не менше 4-х символів')
          .max(10, 'Поле "Номер автомобіля" повинно містити не більше 10-х символів')
          .required('Поле "Номер автомобіля" обов\'язкове'),
        document: Yup.object().shape({
          number: useTransportDoc
            ? Yup.string().nullable().required('Поле "Номер документа" обов\'язкове')
            : Yup.string().nullable(),
          pictures: Yup.array().of(Yup.mixed()),
          pictureFiles: Yup.array()
            .of(Yup.mixed())
            .when(['number', 'pictures'], {
              is: (number: string, pictures: any) =>
                number && pictures && pictures.filter((p: any) => !p.isDeleted).length < 1,

              then: (() => {
                const validation = Yup.array().of(Yup.mixed());

                if (isOrdering || isDirector) {
                  return validation.min(1, 'Загрузіть фото документу').required('Загрузіть фото документу');
                }

                if (isSecurity && +status !== 1) {
                  return validation.min(1, 'Загрузіть фото документу').required('Загрузіть фото документу');
                }

                return validation;
              })(),
            })
            .when(['number', 'pictures'], {
              is: (number: string, pictures: any) => number && (!pictures || !pictures.length),
              then: (() => {
                let validation = Yup.array().of(Yup.mixed());

                if (isOrdering || isDirector) {
                  validation = validation.min(1, 'Загрузіть фото документу').required('Загрузіть фото документу');
                }

                if (isSecurity && status !== 1) {
                  validation = validation.min(1, 'Загрузіть фото документу').required('Загрузіть фото документу');
                }

                return validation;
              })(),
            }),
        }),
      },
      [
        ['type', 'number'],
        ['type', 'pictureFiles'],
        ['number', 'type'],
        ['number', 'pictures'],
        ['number', 'pictureFiles'],
        ['pictures', 'pictureFiles'],
      ],
    ),
    trailer: Yup.object()
      .shape(
        {
          licensePlate: Yup.string().when(['document.number'], {
            is: (number: string) => !!number,
            then: Yup.string().nullable().required('Поле "Номер причепа" обов\'язкове'),
          }),
          document: Yup.object().when('licensePlate', {
            is: (licensePlate: string) => !!licensePlate,
            then: Yup.object().shape({
              number: useTransportDoc
                ? Yup.string().nullable().required('Поле "Номер техпаспорту" обов\'язкове')
                : Yup.string().nullable(),
              pictures: Yup.array().of(Yup.mixed()).nullable(),
              pictureFiles: Yup.array()
                .of(Yup.mixed())
                .when(['pictures'], {
                  is: (pictures: any) => !pictures || !pictures.length,
                  then: (() => {
                    let validation = Yup.array().of(Yup.mixed()).nullable();

                    if ((isOrdering || isDirector) && useTransportDoc) {
                      validation = validation
                        .min(1, 'Загрузіть документів транспорту')
                        .required('Загрузіть документів транспорту');
                    }

                    return validation;
                  })(),
                }),
            }),
          }),
        },
        [['document', 'licensePlate']],
      )
      .nullable(),
    // entryVehicleWeight: Yup.number()
    //   .nullable()
    //   .when('statusId', {
    //     is: (statusId: number) => isKiosk || statusId === 1,
    //     then: Yup.number()
    //       .nullable()
    //       .positive('Значення має бути цілим числом')
    //       .moreThan(1, 'Значення має бути цілим числом')
    //       .lessThan(2000001, 'Максимальне значення 2000000')
    //       .integer('Значення має бути цілим числом')
    //       .required('Поле "Вага" обов\'язкове'),
    //   }),
    isTransportDocumentValid: (() => {
      let validation = Yup.boolean();
      if (isOrdering || isDirector) {
        validation = validation
          .oneOf([true], 'Підтвердіть верифікацію')
          .required('Поле "Документи верифіковано" обов\'язкове');
      }

      return validation;
    })(),
  });
};

export default validationSchema;
